import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { routes } from '@libs/utils';
import { SiteSetupComponentService, StepNumberEnum } from '../site-setup/site-setup.component.service';
import { SiteSetupNavbarComponent } from '../site-setup/components/site-setup-navbar/site-setup-navbar.component';

@Component({
  selector: 'lib-practice-manager',
  imports: [CommonModule, TranslateModule, SiteSetupNavbarComponent, RouterModule],
  templateUrl: './practice-manager.component.html',
  styleUrl: './practice-manager.component.scss',
})
export class PracticeManagerComponent {
  private readonly service = inject(SiteSetupComponentService);
  public vm = this.service.viewModel;
  public routes = routes;

  public StepNumberEnum = StepNumberEnum;
}
